
<!-- Error State -->
<div *ngIf="error" class="bg-red-50 border border-red-200 rounded-md p-4">
  <div class="flex">
    <svg class="h-5 w-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
    <div class="ml-3">
      <h3 class="text-sm font-medium text-red-800">{{ error }}</h3>
    </div>
  </div>
</div>

<!-- Main Content -->
<div *ngIf="template" class="space-y-6">

    <div class="flex justify-center">
        <pdf-viewer
        [src]="pdfSrc"
        [render-text]="true"
        style="display: block; height: 80vh; width: 80%; max-width: 900px; border: 1px solid black; border-radius: 8px;"
        ></pdf-viewer>
    </div>
    <!-- Mapeo de Campos -->
    <div class="bg-white shadow rounded-lg mt-6">
        <div class="px-6 py-4 border-b border-gray-200">
            <h2 class="text-lg font-medium text-gray-900">Campos del PDF</h2>
            <p class="text-sm text-gray-500">Asigna cada campo del PDF a un valor</p>
        </div>
        
        <div class="p-6">
            <!-- Mensaje cuando no hay campos -->
            <div *ngIf="camposPDF.length === 0" class="text-center py-8">
                <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                <h3 class="mt-2 text-sm font-medium text-gray-900">No hay campos extraídos</h3>
                <p class="mt-1 text-sm text-gray-500">Esta plantilla no tiene campos extraídos aún. Necesitas extraer los campos primero.</p>
                <div class="mt-4">
                    <button 
                        (click)="extraerCampos()"
                        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
                        Extraer Campos del PDF
                    </button>
                </div>
            </div>

            <!-- Grid de campos cuando existen -->
            <div *ngIf="camposPDF.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div *ngFor="let campo of camposPDF" class="border border-gray-200 rounded-lg p-4">
                    <label class="block text-sm font-medium text-gray-700 mb-1" *ngIf="!campo.value">
                      Campo PDF: <span class="font-mono text-red-600">{{ campo.name }}</span>
                    </label>
                    <label class="block text-sm font-medium text-gray-700 mb-1" *ngIf="campo.value">
                      Campo PDF: <span class="font-mono text-green-600">{{ campo.name }}</span>
                    </label>
                  
                    <app-custom-dropdown
                      [(ngModel)]="mapeoCampos[campo.name]"
                      [options]="datosDisponibles"
                      [group]="true"
                      optionGroupLabel="label"
                      optionGroupChildren="options"
                      optionLabel="label"
                      optionValue="key"
                      placeholder="-- Seleccionar campo --"
                      [showClear]="true"
                      [filter]="true"
                    ></app-custom-dropdown>
                </div>
            </div>
            
            <!-- Botones de acción -->
            <div class="mt-6 flex justify-end space-x-3">
                <button 
                    (click)="guardarMapeo()"
                    [disabled]="!hasChanges()"
                    class="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>
